import { IApiError, TApiErrorCallback } from "../api.interfaces";
import { IAuthFailureHandlerApi, IPerTypeStrategy } from "./interfaces";

export class InvalidPermissionsStrategy implements IPerTypeStrategy {
    constructor(private readonly api: IAuthFailureHandlerApi) {}

    handle(error: IApiError, errorCallback: TApiErrorCallback | undefined): void {
        this.api.forget();
        errorCallback?.(error);
    }
}
